const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const { a, li, ul } = cfg.h

  return (
    ul('.uitagslist', subj.tags.map(tag => li([
      a({
        href: `/tag/#${tag}`,
        title: tag
      }, tag)
    ])))
  )
}

export default {
  type: 'uitagslist',
  xvnode
}
